export default function PaymentService($http, API_LEGACY, API_SERVER) {
    return {
        bookingPaymentReadyValidatedByApi: false,

        getPaymentUrl: function (bookingId) {
            const url = API_LEGACY + `/Booking/GetPaymentURL/${bookingId}`;
            return $http.get(url).then(function (result) {
                return result.data;
            });
        },

        getPaymentResult: function (bookingId) {
            const url = API_LEGACY + `/Booking/GetPaymentResult/${bookingId}`;
            return $http.get(url).then(function (result) {
                return result.data;
            });
        },

        create: function (bookingId) {
            const payload = {
                bookingId: bookingId,
            };
            const url = `${API_SERVER}/payments`;
            const headers = {
                endpointType: "noTokenRequired",
            };
            return $http
                .post(url, payload, { headers: headers })
                .then((res) => {
                    return res.data;
                });
        },

        get: function (bookingId) {
            const url = `${API_SERVER}/payments?bookingId=${bookingId}`;
            const headers = {
                endpointType: "noTokenRequired",
            };
            return $http.get(url, { headers: headers }).then(function (result) {
                return result.data;
            });
        },

        getByPaymentID: function (paymentId) {
            const url = `${API_SERVER}/payments/nets:paymentid?paymentId=${paymentId}`;
            const headers = {
                endpointType: "noTokenRequired",
            };
            return $http.get(url, { headers: headers }).then(function (result) {
                return result.data;
            });
        },
    };
}
